export default class AuthError extends Error {
  constructor() {
    super('Ocurrió un error al procesar tu solicitud. Intenta de nuevo más tarde');
    this.name = 'AuthError';
  }
}
